import React, { useState, useEffect, useRef } from 'react';
import './Carousel.css';

const Carousel = ({ items, renderItem }) => {
  const [currentIndex, setCurrentIndex] = useState(items.length); // Start from middle set
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const trackRef = useRef(null);
  
  // Dynamic items per view based on screen size
  const itemsPerView = isMobile ? 1 : 3;
  
  // Create extended array with more buffer for seamless looping
  const extendedItems = [...items, ...items, ...items, ...items, ...items];

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleTransitionEnd = () => {
    setIsTransitioning(false);
    
    // Seamlessly reset position without visible jump
    if (currentIndex >= items.length * 2 - 1) {
      // We're at the end of second set, move to equivalent position in first set
      setCurrentIndex(items.length + (currentIndex % items.length));
    } else if (currentIndex <= items.length) {
      // We're at the beginning of first set, move to equivalent position in second set
      setCurrentIndex(items.length + (currentIndex % items.length));
    }
  };

  const nextSlide = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrentIndex(prev => prev + 1);
  };

  const prevSlide = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrentIndex(prev => prev - 1);
  };

  return (
    <div className="destinations-carousel">
      <button 
        className="carousel-btn prev-btn" 
        onClick={prevSlide}
        aria-label="Previous"
      >
        <i className="fas fa-chevron-left"></i>
      </button>
      <div className="destinations-wrapper">
        <div 
          ref={trackRef}
          className="carousel-track"
          style={{
            transform: isMobile 
              ? `translateX(-${currentIndex * 100}%)`
              : `translateX(-${(currentIndex - 1) * (100 / itemsPerView)}%)`,
            transition: isTransitioning ? 'transform 0.6s cubic-bezier(0.4, 0.0, 0.2, 1)' : 'none'
          }}
          onTransitionEnd={handleTransitionEnd}
        >
          {extendedItems.map((item, index) => (
            <div 
              key={`${index}-${item.id || index}`} 
              className={`carousel-item ${
                isMobile ? 
                  (index === currentIndex ? 'active' : 'hidden') :
                  (index === currentIndex ? 'active' : 
                   index === currentIndex + 1 ? 'next' : 
                   index === currentIndex - 1 ? 'prev' : 'hidden')
              }`}
            >
              {renderItem(item)}
            </div>
          ))}
        </div>
      </div>
      <button 
        className="carousel-btn next-btn" 
        onClick={nextSlide}
        aria-label="Next"
      >
        <i className="fas fa-chevron-right"></i>
      </button>
    </div>
  );
};

export default Carousel;
